import { isTabFilterKey } from '@office-start/edgeworth-models';
import { format } from '@office-start/string-formatter-utility';
import { useMemo } from 'react';
import { getEmptyStateAadMap, } from '../utilities/getEmptyStateAadMap';
import { getEmptyStateMsaMap } from '../utilities/getEmptyStateMsaMap';
/**
 * Custom hook for determining which empty state to use
 */
export function useEmptyState(_a) {
    var actions = _a.actions, emptyStateResources = _a.emptyStateResources, filterText = _a.filterText, areFiltersApplied = _a.areFiltersApplied, currentTab = _a.currentTab, darkMode = _a.darkMode, isMsa = _a.isMsa, isCustomPivot = _a.isCustomPivot, isDesktopApp = _a.isDesktopApp, isEmptyTag = _a.isEmptyTag, isError = _a.isError;
    var emptyStateMap = useMemo(function () {
        return isMsa
            ? getEmptyStateMsaMap(emptyStateResources, darkMode, isDesktopApp)
            : getEmptyStateAadMap({
                actions: actions,
                emptyStateResources: emptyStateResources,
                darkMode: darkMode,
                isDesktopApp: isDesktopApp,
            });
    }, [actions, darkMode, emptyStateResources, isDesktopApp, isMsa]);
    return useMemo(function () {
        if (isError) {
            return {
                emptyStateModel: emptyStateMap.get('error'),
                isPlainTabEmptyState: true,
            };
        }
        else if (isEmptyTag) {
            return {
                emptyStateModel: emptyStateMap.get('emptyTag'),
                isPlainTabEmptyState: true,
            };
        }
        else if (filterText) {
            if (isCustomPivot) {
                emptyStateMap.set('custom', {
                    zeroExperienceTitle: format(emptyStateResources.customPivotEmptyStateTitle, filterText),
                    imageName: 'local_light_and_dark',
                });
                return {
                    emptyStateModel: emptyStateMap.get('custom'),
                    isPlainTabEmptyState: false,
                };
            }
            else if (areFiltersApplied) {
                emptyStateMap.set('filterandsearch', {
                    zeroExperienceSubtitle: format(emptyStateResources.noResultsFoundWithFilterSubtitle, filterText),
                    imageName: isMsa
                        ? darkMode
                            ? 'search_dark_msa'
                            : 'search_light_msa'
                        : darkMode
                            ? 'search_dark'
                            : 'search_light',
                });
                return {
                    emptyStateModel: emptyStateMap.get('filterandsearch'),
                    isPlainTabEmptyState: false,
                };
            }
            else {
                emptyStateMap.set('search', {
                    zeroExperienceSubtitle: format(emptyStateResources.noResultsFoundSubtitle, filterText),
                    imageName: isMsa
                        ? darkMode
                            ? 'search_dark_msa'
                            : 'search_light_msa'
                        : darkMode
                            ? 'search_dark'
                            : 'search_light',
                });
                return {
                    emptyStateModel: emptyStateMap.get('search'),
                    isPlainTabEmptyState: false,
                };
            }
        }
        else if (areFiltersApplied) {
            return {
                emptyStateModel: emptyStateMap.get('filter'),
                isPlainTabEmptyState: false,
            };
        }
        else {
            if (isTabFilterKey(currentTab)) {
                return {
                    emptyStateModel: emptyStateMap.get(currentTab),
                    isPlainTabEmptyState: true,
                };
            }
            else {
                return undefined;
            }
        }
    }, [
        areFiltersApplied,
        currentTab,
        darkMode,
        emptyStateMap,
        emptyStateResources,
        filterText,
        isCustomPivot,
        isEmptyTag,
        isError,
        isMsa,
    ]);
}
//# sourceMappingURL=useEmptyState.js.map